"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importStar(require("react"));
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const base_layout_1 = require("../../common/base_layout");
const bread_crumbs_1 = require("../../common/bread_crumbs");
const apis_1 = require("../../../service/apis");
const notification_1 = require("../../common/notification");
const device_information_1 = __importDefault(require("./device_information"));
const provision_input_1 = __importDefault(require("./provision_input"));
const execution_status_1 = __importDefault(require("./execution_status"));
const functions_1 = require("../../../common/functions");
const constants_1 = require("../../../common/constants");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const CONSTANTS = __importStar(require("../../../common/constants"));
const hooks_1 = require("../../../common/hooks");
function Content(props) {
    return ((0, jsx_runtime_1.jsxs)(awsui_components_react_1.SpaceBetween, { size: "l", children: [(0, jsx_runtime_1.jsx)(device_information_1.default, { deviceCode: props.deviceCode, userName: props.userName, provisionStatus: props.provisionStatus, userCode: props.userCode }), (0, jsx_runtime_1.jsx)(provision_input_1.default, { provisionStatus: props.provisionStatus }), (0, jsx_runtime_1.jsx)(execution_status_1.default, { provisionStatus: props.provisionStatus })] }));
}
function ProvisionStatusPage() {
    const { processId, nodeId, userName, deviceCode } = (0, react_router_dom_1.useParams)();
    const [provisionStatus, setProvisionStatus] = (0, react_1.useState)();
    const [notification, setNotification] = (0, react_1.useState)([]);
    const [isAutoRefreshDisabled, setIsAutoRefreshDisabled] = (0, react_1.useState)(false);
    const refreshIntervalToString = new Map([
        [0, 'Off'],
        [90, '90s'],
        [120, '120s'],
    ]);
    const [refreshInterval, setRefreshInterval] = (0, react_1.useState)(120);
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const [bundleLoaded, setBundleLoaded] = react_1.default.useState(false);
    // Get userCode from query params. It's used to decide if the page should show a button to FIT device auth
    const query = (0, hooks_1.useQuery)();
    const userCode = query.get('userCode');
    let refreshIntervalString = (0, functions_1.getMapValue)(refreshIntervalToString, refreshInterval, constants_1.EMPTY_STRING);
    function fetchProvisionDetails() {
        (0, apis_1.getApis)()
            .getProvisionStatus({ userName: userName, authDeviceCode: deviceCode })
            .then((response) => {
            setProvisionStatus(response);
            setNotification([]);
            const provisionStatusType = response.provisionStatus;
            if (provisionStatusType === 'Provisioning_Failed' ||
                provisionStatusType === 'Execution_Failed' ||
                provisionStatusType === 'Execution_Succeed') {
                onRefreshIntervalSelection(0);
                setIsAutoRefreshDisabled(true);
            }
        })
            .catch((error) => {
            console.log(error.message);
            setProvisionStatus(undefined);
            let errorHeader;
            if (error.response != null && (error.response.status == 403 || error.response.status == 401)) {
                errorHeader =
                    localeBundle === undefined ? 'Unauthorized user' : localeBundle.getMessage('unauthorized-user');
            }
            else {
                errorHeader =
                    localeBundle === undefined
                        ? 'Something went wrong'
                        : localeBundle.getMessage('something-wrong');
            }
            let errorContent;
            if (error.response == null) {
                errorContent = localeBundle.getMessage('refresh-page');
            }
            else if (error.response.status == 403 || error.response.status == 401) {
                errorContent =
                    localeBundle === undefined
                        ? `User is not authorized to provision devices or view information related to provisioning. To gain access, please contact the owners of this process to request permission. Refer to ${CONSTANTS.AUTHZ_DOCUMENTATION_WIKI_LINK} for more details.`
                        : `${localeBundle.formatMessage((0, functions_1.getErrorMessageLocaleBundleKeyFromOperationName)(constants_1.EDM_API_TO_DEVICE_GROUP_OPERATION_MAP.get(constants_1.EDM_GET_PROVISION_STATUS_API_NAME)), {
                            wikiLink: CONSTANTS.AUTHZ_DOCUMENTATION_WIKI_LINK,
                        })}`;
            }
            else {
                errorContent = `Error: ${error.response.data.message} ${localeBundle === undefined
                    ? 'Please kindly refresh the page. If the issue persists, please contact the service owner.'
                    : localeBundle.getMessage('refresh-page')}`;
            }
            setNotification([
                {
                    header: errorHeader,
                    type: 'error',
                    content: errorContent,
                    dismissible: true,
                    dismissLabel: 'Dismiss message',
                    onDismiss: () => setNotification([]),
                },
            ]);
        });
    }
    (0, react_1.useEffect)(() => {
        if (localeBundle !== undefined) {
            setBundleLoaded(true);
        }
    });
    (0, react_1.useEffect)(() => {
        console.log('Refresh interval is %d ms', refreshInterval);
        if (refreshInterval > 0) {
            fetchProvisionDetails();
            const interval = setInterval(fetchProvisionDetails, refreshInterval * 1000);
            return () => clearInterval(interval);
        }
    }, [refreshInterval, deviceCode, bundleLoaded]);
    const onRefreshIntervalSelection = (refreshInterval) => {
        setRefreshInterval(refreshInterval);
        refreshIntervalString = (0, functions_1.getMapValue)(refreshIntervalToString, refreshInterval, constants_1.EMPTY_STRING);
    };
    return ((0, jsx_runtime_1.jsx)(base_layout_1.BaseLayout, { breadcrumbs: (0, jsx_runtime_1.jsx)(bread_crumbs_1.Breadcrumbs, { items: [
                {
                    text: localeBundle === undefined
                        ? 'Provision status'
                        : localeBundle.getMessage('provision-status'),
                    href: '#/provision/provisions',
                },
                {
                    text: deviceCode,
                    href: '#/provision/' + deviceCode + '/status',
                },
            ] }), contentHeader: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Header, { variant: "h1", actions: (0, jsx_runtime_1.jsxs)(awsui_components_react_1.SpaceBetween, { size: 'xxxs', direction: "horizontal", children: [(0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { iconName: "refresh", variant: "normal", onClick: () => fetchProvisionDetails() }), (0, jsx_runtime_1.jsx)(awsui_components_react_1.ButtonDropdown, { items: [
                            { text: (0, functions_1.getMapValue)(refreshIntervalToString, 0, ''), id: '0' },
                            { text: (0, functions_1.getMapValue)(refreshIntervalToString, 90, ''), id: '90' },
                            { text: (0, functions_1.getMapValue)(refreshIntervalToString, 120, ''), id: '120' },
                        ], disabled: isAutoRefreshDisabled, onItemClick: (event) => onRefreshIntervalSelection(Number(event.detail.id)), children: refreshIntervalString })] }), children: deviceCode }), notifications: (0, jsx_runtime_1.jsx)(notification_1.Notification, { items: notification }), content: (0, jsx_runtime_1.jsx)(Content, { deviceCode: deviceCode, userName: userName, provisionStatus: provisionStatus, userCode: userCode }), contentType: "default" }));
}
exports.default = ProvisionStatusPage;
